'use client';

import React from 'react';

const WhatWeAreNot = () => {
  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-6 leading-tight">
              What AI Change Leaders Is - and Is Not
            </h2>
          </div>

          {/* Contrast grid */}
          <div className="grid md:grid-cols-2 gap-12">
            {/* What we are */}
            <div>
              <div className="mb-6">
                <div className="inline-block px-4 py-2 bg-[#0A2540] text-white font-semibold font-body text-sm uppercase tracking-wide">
                  What We Are
                </div>
              </div>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#0A2540] mt-2"></div>
                  <span className="text-lg text-gray-800 font-body">An independent, cross-industry authority</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#0A2540] mt-2"></div>
                  <span className="text-lg text-gray-800 font-body">Defining a new discipline</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#0A2540] mt-2"></div>
                  <span className="text-lg text-gray-800 font-body">Defining emerging cross-industry standards</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#0A2540] mt-2"></div>
                  <span className="text-lg text-gray-800 font-body">Neutral and institution-focused</span>
                </li>
              </ul>
            </div>

            {/* What we are not */}
            <div>
              <div className="mb-6">
                <div className="inline-block px-4 py-2 bg-gray-300 text-gray-700 font-semibold font-body text-sm uppercase tracking-wide">
                  What We Are Not
                </div>
              </div>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-gray-400 mt-2"></div>
                  <span className="text-lg text-gray-600 font-body">An AI consultancy</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-gray-400 mt-2"></div>
                  <span className="text-lg text-gray-600 font-body">A technology vendor</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-gray-400 mt-2"></div>
                  <span className="text-lg text-gray-600 font-body">A tool or platform provider</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-gray-400 mt-2"></div>
                  <span className="text-lg text-gray-600 font-body">Personality-led or founder-focused</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Credibility statement */}
          <div className="mt-16 p-8 bg-white border-2 border-gray-200">
            <p className="text-lg text-gray-800 font-body leading-relaxed">
              AI Change Leaders exists to establish the discipline, standards, and systems that enable organisations to lead continuous transformation. We do not build AI. We do not sell tools. We define the leadership capability that makes AI work.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeAreNot;